// Form to create a new experiment with a name, and description. it uses the submit button component and upon completion redirects to manage experiment/experiment_id which is taken from the respone

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOasisBackend } from '../../../hooks/useOasisBackend';
import SubmitButton from '../SubmitButton';
import { ExperimentClassEnum, Experiment as ExperimentType } from '../../../api/OasisBackendApi';

const CreateExperiment: React.FC = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [experimentClass, setExperimentClass] = useState<ExperimentClassEnum>(ExperimentClassEnum.LLMExperiment);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const db = useOasisBackend();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await db.endpoints.testsuite.testsuiteApiCreateExperimentCreate({
        name,
        description,
        experiment_class: experimentClass,
      });

      // Redirect to manage experiment page
      navigate(`/manage-experiment/${response.data.id}`);
    } catch (error) {
      console.error('Error creating experiment:', error);
      alert('Failed to create experiment. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-10">
      <h2 className="text-2xl font-bold mb-5">Create New Experiment</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block mb-1">Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div>
          <label htmlFor="description" className="block mb-1">Description</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div>
          <label htmlFor="experimentClass" className="block mb-1">Experiment Class</label>
          <select
            id="experimentClass"
            value={experimentClass}
            onChange={(e) => setExperimentClass(e.target.value as ExperimentClassEnum)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={ExperimentClassEnum.LLMExperiment}>LLM Experiment</option>
            <option value={ExperimentClassEnum.SearchExperiment}>Search Experiment</option>
          </select>
        </div>
        <SubmitButton
          isSubmitting={isSubmitting}
          submitText="Create Experiment"
          loadingText="Creating..."
        />
      </form>
    </div>
  );
};

export default CreateExperiment;
